import { render, staticRenderFns } from "./InvestInPlace.vue?vue&type=template&id=0feeca13&scoped=true&"
import script from "./InvestInPlace.vue?vue&type=script&lang=js&"
export * from "./InvestInPlace.vue?vue&type=script&lang=js&"
import style0 from "./InvestInPlace.vue?vue&type=style&index=0&id=0feeca13&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0feeca13",
  null
  
)

export default component.exports